import * as userManager from '$domain/model/user/user.manager'

export const getUserIdData = () => {
  return userManager.getUserIdData()
}



// WEBPACK FOOTER //
// ./src/services/user/userIdData/userIdData.service.ts